<template>
  <div class="search-chat">
    <div v-if="!perplexicaUrl" class="loading">Loading...</div>
    <iframe
      v-else
      id="perplexica-search-chat"
      ref="iframe"
      :src="perplexicaUrl"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SearchChat',
  data() {
    return {
      perplexicaUrl: null,
    }
  },
  created() {
    // URLエンコードしてReactに渡す
    this.perplexicaUrl = `${process.env.VUE_APP_PERPLEXICA_URL}`

    // window メッセージイベント登録
    window.addEventListener('message', this.handleMessage)
  },
  beforeUnmount() {
    // コンポーネント破棄時にイベント解除
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      const data = event.data

      // 信頼できる origin のみ処理する場合はチェック
      // if (event.origin !== 'https://mi-chao.com') return

      if (data.type === 'REQUEST_USER_ID') {
        const iframe = this.$refs.iframe
        const userId = this.$store.state.email

        iframe.contentWindow.postMessage(
          { type: 'RESPONSE_USER_ID', userId },
          '*',
        )
      }

      if (data.type === 'GA_EVENT') {
        window.gtag('event', 'API', {
          event_name: '検索しチャオ',
          model: data.params.model,
          id: this.$store.state.userId,
        })
      }
    },
  },
}
</script>

<style scoped>
.perplexica-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

iframe {
  flex-grow: 1;
  border: none;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.5rem;
}
</style>
